// extracted by mini-css-extract-plugin
export default {"defaultWrapper":"Skeleton__defaultWrapper--15E","defaultLoader":"Skeleton__defaultLoader--3dm"};